module.exports = __webpack_public_path__ + "img/vps.43eb3ea4.webp";